import { type SVGProps } from 'react';
import { type IconProps } from '@/components/uielements/icon/types';

export const ExclamationCircle = ({
  title,
  width,
  height,
  ...otherProps
}: IconProps & SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...otherProps}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width ?? '24'}
      height={height ?? '24'}
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
    >
      <title>{title ?? 'Exclamation Circle'}</title>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
      />
    </svg>
  );
};
